import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFirewall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="firewall,wall"><path d="M12 3.75H3.75V9.25M12 3.75V9.25M12 3.75H20.25V9.25M12 9.25H3.75M12 9.25H20.25M3.75 9.25H7.75M3.75 9.25V14.75M20.25 9.25H16.25M20.25 9.25V14.75M3.75 14.75H12M3.75 14.75V20.25H12M3.75 14.75H7.75M12 14.75V20.25M12 14.75H20.25M12 20.25H20.25V14.75M20.25 14.75H16.25M7.75 9.25V14.75M7.75 9.25H16.25M7.75 14.75H16.25M16.25 9.25V14.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFirewall;
